import { invisiblyApi } from 'src/redux/api/invisibly-api';
import { APITagType } from 'src/redux/api/invisibly-api.types';
import type {
  ActivityInsightsResponse,
  ActivityInsightsUsersResponse,
  GetActivityInsightsParams,
  GetActivityInsightsUsersParams,
} from '../types/usage-insights.types';

const ACTIVITY_INSIGHTS_TIMEOUT_MS = 90_000;
const ACTIVITY_NARRATIVE_TIMEOUT_MS = 120_000;

const activityInsightsEndpoints = invisiblyApi.injectEndpoints({
  endpoints: (builder) => ({
    getActivityInsights: builder.query<ActivityInsightsResponse, GetActivityInsightsParams>({
      query: ({ from, to, workspace_id: workspaceId, narrative }) => ({
        method: 'GET',
        url: 'b2b/manage/activity/insights',
        params: {
          from,
          to,
          ...(workspaceId ? { workspace_id: workspaceId } : {}),
          ...(narrative !== undefined ? { narrative } : {}),
        },
        handleErrorGlobally: false,
        timeout: narrative === true ? ACTIVITY_NARRATIVE_TIMEOUT_MS : ACTIVITY_INSIGHTS_TIMEOUT_MS,
      }),
      providesTags: [{ id: 'INSIGHTS', type: APITagType.ActivityInsights }],
    }),
    getActivityInsightsUsers: builder.query<ActivityInsightsUsersResponse, GetActivityInsightsUsersParams>({
      query: ({ from, to, workspace_id: workspaceId, page, page_size: pageSize }) => ({
        method: 'GET',
        url: 'b2b/manage/activity/insights/users',
        params: {
          from,
          to,
          ...(workspaceId ? { workspace_id: workspaceId } : {}),
          ...(page !== undefined ? { page } : {}),
          ...(pageSize !== undefined ? { page_size: pageSize } : {}),
        },
        handleErrorGlobally: false,
        timeout: ACTIVITY_INSIGHTS_TIMEOUT_MS,
      }),
      providesTags: [{ id: 'USERS', type: APITagType.ActivityInsightsUsers }],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetActivityInsightsQuery,
  useGetActivityInsightsUsersQuery,
} = activityInsightsEndpoints;
